var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.889 4.11087C11.3837 3.60567 10.7955 3.20907 10.1406 2.93208C9.46276 2.64537 8.74255 2.5 8 2.5C7.25746 2.5 6.53725 2.64538 5.85938 2.93208C5.20449 3.20907 4.61625 3.60567 4.11104 4.11086C3.60581 4.61607 3.20916 5.20429 2.93214 5.85919C2.64539 6.53708 2.5 7.25735 2.5 7.99999C2.5 8.74263 2.6454 9.46291 2.93214 10.1408C3.20916 10.7957 3.60581 11.3839 4.11104 11.8891C4.61626 12.3943 5.20449 12.7909 5.85939 13.0679C6.53725 13.3546 7.25746 13.5 8 13.5C8.74254 13.5 9.46276 13.3546 10.1406 13.0679C10.7955 12.7909 11.3837 12.3943 11.889 11.8891C12.3942 11.3839 12.7908 10.7957 13.0679 10.1408C13.3546 9.46291 13.5 8.74264 13.5 8C13.5 7.25735 13.3546 6.53709 13.0679 5.85919C12.7908 5.2043 12.3942 4.61608 11.889 4.11087ZM8.42432 8.24262L10.3335 10.1518L9.90916 10.5761L7.99999 8.66695L6.09083 10.5761L5.66651 10.1518L7.57566 8.24263L5.66652 6.33348L6.09085 5.90915L8 7.81829L9.90915 5.90915L10.3335 6.33347L8.42432 8.24262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossFilledIcon);
export default __webpack_public_path__ + "static/media/cross_filled_icon.954e5ada23af323d7b2259a195f1107a.svg";
export { ForwardRef as ReactComponent };